import React, { JSX } from 'react'
import styles from './Section.module.css'
import { HoverState } from '../../../assets/utils/cursorTypes';

export type SectionProps = {
    title: string;
    element: JSX.Element;
    blurElement: string;
    setBlurElement: React.Dispatch<React.SetStateAction<string>>;
    setHoverElement: React.Dispatch<React.SetStateAction<HoverState>>;
    isPage: boolean;
}

const Section = (props: SectionProps) => {


    const handleMouseEnter = () => {
        props.setBlurElement(props.title);
        props.setHoverElement('pointer');
    }
    const handleMouseLeave = () => {
        props.setBlurElement('');
        props.setHoverElement('normal');
    }

    return (
        <div 
            className={`
                ${styles.container}
                ${props.blurElement !== props.title && props.blurElement !== '' && styles.blur}
            `}
            id={props.title}
        >
            <div 
                className={styles.header} 
                onMouseEnter={() => handleMouseEnter()}
                onMouseLeave={() => handleMouseLeave()}
            >
                <span className={styles.section_title}>{props.title}</span>
                <div className={styles.headerLine}>
                    <div className={styles.lines}>
                        <div className={styles.container_lines}>
                            <div className={styles.line1}></div>
                            <div className={styles.line2}></div>
                        </div>
                        <div className={styles.line3}>
                            <div className={styles.lineArrow1}></div>
                            <div className={styles.lineArrow2}></div>
                        </div>
                    </div>
                </div>
            </div>
            <div 
                className={styles.content}
            >
                <div className={styles.space}></div>
                {props.element}
            </div>
        </div>
    )
}

export default Section
